<template>

    <b-row>

        <b-col>
            
            <b-form-select
                v-model="localFilterItem.group"
                :options="validFilterGroups"
                text-field="name"
                value-field="item"/>  

        </b-col>
        
        <b-col>
            
            <b-form-select
                v-model="localFilterItem.field"
                :options="validFilterFields"
                text-field="name"
                value-field="item"/>  

        </b-col>

        <b-col>
            <b-form-select
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && 
                (localFilterItem.field == 'completed'
                || localFilterItem.field == 'context'
                || localFilterItem.field == 'folder'
                || localFilterItem.field == 'priority'
                || localFilterItem.field == 'star'
                || localFilterItem.field == 'status')"
                v-model="localFilterItem.operator"
                :options="[{name: '=', item: '$eq'}]"
                value-field="item"
                text-field="name"/>
            <b-form-select
                v-else-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && 
                (localFilterItem.field == 'title'
                || localFilterItem.field == 'notes')"
                v-model="localFilterItem.operator"
                :options="[{name: 'contains', item: '$regex'}]"
                value-field="item"
                text-field="name"/> 
            <b-form-select
                v-else-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null)"
                v-model="localFilterItem.operator"
                :options="taskFilterOps"
                value-field="item"
                text-field="name"/> 
        </b-col>

        <b-col cols="3">
            
            <b-form-select
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && localFilterItem.field == 'completed'"
                v-model="localFilterItem.value"
                :options="yesorno"
                value-field="item"
                text-field="name"/>

            <b-form-select
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && localFilterItem.field == 'context'"
                v-model="localFilterItem.value" 
                :options="$store.getters.getContextsForFilter"
                value-field="name"
                text-field="name"/>

            <b-form-select 
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && localFilterItem.field == 'folder'"
                v-model="localFilterItem.value" 
                :options="$store.getters.getFolders"/>

            <b-form-select 
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && localFilterItem.field == 'priority'"
                v-model="localFilterItem.value" 
                :options="validPriorities"
                value-field="name"
                text-field="name"/>

            <b-form-select
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && localFilterItem.field == 'star'"
                v-model="localFilterItem.value"
                :options="yesorno"
                value-field="item"
                text-field="name"/>

            <b-form-select
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) && localFilterItem.field == 'status'"
                v-model="localFilterItem.value"
                :options="validStatuses"
                value-field="item"
                text-field="name"/>

            <b-form-input
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) 
                && (localFilterItem.field == 'notes' 
                || localFilterItem.field == 'title')"
                v-model="localFilterItem.value"
                :trim="true"/>

            <b-form-input
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) 
                && (localFilterItem.field == 'length')"
                v-model.number="localFilterItem.value"
                type="number"
                :trim="true"/>

            <b-form-datepicker 
                v-if="(typeof localFilterItem.field != 'undefined' && localFilterItem.field !== null) 
                    && (localFilterItem.field == 'added' 
                        || localFilterItem.field == 'completedDate' 
                        || localFilterItem.field == 'due' 
                        || localFilterItem.field == 'start')"
                v-model="localFilterItem.value"
                :date-format-options="dateFormatOptions"
                :today-button="true"/>

        </b-col>

        <b-col cols="2" class="d-flex align-items-center" style="gap: 1.25rem; padding-left: 1rem;">
            <span class="filter-row-btn filter-row-add" @click="add" title="Add row">+</span>
            <span class="filter-row-btn filter-row-reset" @click="clear" title="Clear row">↺</span>
            <span class="filter-row-btn filter-row-delete" @click="remove" title="Remove row">×</span>
        </b-col>

    </b-row>

</template>

<script>

import taskOps from '../mixins/taskOps'
import genericOps from '../mixins/genericOps'

export default {    
    name: 'FilterRow',
    mixins: [genericOps, taskOps],
    props: {
        filterItem: {
            type: Object,
            default: {}
        },
        index: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            dateFormatOptions: { 'year': 'numeric', 'month': 'numeric', 'day': '2-digit', 'weekday': 'short' },
            validFilterGroups: [
                { name: 'A', item: 'a', default: true},
                { name: 'B', item: 'b'},
                { name: 'C', item: 'c'},
                { name: 'D', item: 'd'},
                { name: 'E', item: 'e'},
                { name: 'F', item: 'f'},
                { name: 'G', item: 'g'},
                { name: 'H', item: 'h'},
                { name: 'I', item: 'i'},
                { name: 'J', item: 'j'},
                { name: 'K', item: 'k'},
                { name: 'L', item: 'l'},
                { name: 'M', item: 'm'},
                { name: 'N', item: 'n'},
                { name: 'O', item: 'o'},
                { name: 'P', item: 'p'},
                { name: 'Q', item: 'q'},
                { name: 'R', item: 'r'},
                { name: 'S', item: 's'},
                { name: 'T', item: 't'},
                { name: 'U', item: 'u'},
                { name: 'V', item: 'v'},
                { name: 'W', item: 'w'},
                { name: 'X', item: 'x'},
                { name: 'Y', item: 'y'},
                { name: 'Z', item: 'z'},
            ],
        }
    },
    computed: {
        localFilterItem: {
            get: function() {
                return this.filterItem
            },
            set: function(newVal) {
                ////console.log(JSON.stringify(newVal))
                this.filterItem = newVal
            }
        }
    },
    watch: {

    },
    methods: {
        add() {
            // 20200331 -- ZWS -- Invoked when the user desires to add a new filter item.
            //
            // Emits: add:filter
            this.$emit('add:filter', this.index)
                        
        },
        clear() {
            // 20200331 -- ZWS -- Nulls out all fields in a filterItem.
            this.localFilterItem.group = null
            this.localFilterItem.field = null
            this.localFilterItem.operator = null
            this.localFilterItem.value = null
        },
        remove() {
            // 20200331 -- ZWS -- Invoked when the user desires to remove the filter item.
            //
            // Emits: remove:filter

            //this.$emit('message:task', true, 'Task Edit', 'Unable to create a new instance this recurring task: ' + e, 'warning')
            this.$emit('remove:filter', this.index)
                        

        }
    }
}
</script>

<style scoped>
.filter-row-btn {
    cursor: pointer;
    font-size: 1.1rem;
    line-height: 1;
    color: #adb5bd;
    user-select: none;
    transition: color 0.15s;
}

.filter-row-btn.filter-row-add:hover    { color: #198754; }
.filter-row-btn.filter-row-reset:hover  { color: #6c757d; }
.filter-row-btn.filter-row-delete:hover { color: #dc3545; }
</style>